import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  LightMode,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  isOpen: boolean;
  dataHeader: string;
  dataBody: string;
  color: string;
  btnAction: string;
  action: () => void;
  onClose: () => void;
}

const ConfirmModal = ({
  isOpen,
  dataHeader,
  dataBody,
  color,
  btnAction,
  action,
  onClose,
}: ConfirmModalProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();

  return (
    <>
      <AlertDialog
        closeOnOverlayClick={false}
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        returnFocusOnClose={false}
        size={{ base: 'sm', lg: 'xl' }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent pos='absolute' top='23%' color='color_main_text' bg='bg_box'>
            <AlertDialogHeader fontSize={{ base: 'medium', md: 'large' }} fontWeight='bold'>
              {dataHeader}
            </AlertDialogHeader>

            <AlertDialogBody>{dataBody}</AlertDialogBody>

            <AlertDialogFooter>
              <LightMode>
                <Button ref={cancelRef} ml={3} color='black' onClick={onClose}>
                  {t('common.cancel')}
                </Button>
                <Button
                  ml={3}
                  colorScheme={color}
                  onClick={() => {
                    action();
                    onClose();
                  }}
                >
                  {btnAction}
                </Button>
              </LightMode>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ConfirmModal;
